var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E8F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12293_33289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8125 11.8047L18.125 8.33594C18.0625 8.30469 18 8.30469 17.9062 8.33594L8.21875 11.8047C8.09375 11.8672 8 11.9609 8 12.1172C8 12.2422 8.09375 12.3672 8.1875 12.3984L12.1562 13.8047V14.1172C12.1562 16.2422 13.3125 18.2422 15.1562 19.2734C16 19.7422 16.9688 19.9922 17.9375 19.9922H18.0625C19.0312 19.9922 19.9688 19.7422 20.8438 19.2734C22.6875 18.2109 23.8438 16.2422 23.8438 14.1172V13.8047L25.3125 13.2734V15.9609H25.2188C24.875 15.9609 24.625 16.2422 24.625 16.5547V18.3359C24.625 18.4922 24.75 18.6484 24.9375 18.6484H26.3125C26.4688 18.6484 26.625 18.5234 26.625 18.3359V16.5547C26.625 16.2109 26.3438 15.9609 26.0312 15.9609H25.9375V13.0547L27.8125 12.3984C27.9375 12.3672 28 12.2422 28 12.1172C28 11.9609 27.9062 11.8672 27.8125 11.8047Z",
    fill: "#3077F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4688 18.8438C22.0625 19.2187 21.625 19.5625 21.125 19.8438C20.1563 20.375 19.125 20.6562 18.0625 20.6562H17.9375C16.875 20.6562 15.8125 20.375 14.875 19.8438C14.375 19.5625 13.9375 19.2187 13.5313 18.8438C11.1563 19.3125 9.375 21.4062 9.375 23.9062V27.375C9.375 27.5312 9.5 27.6875 9.6875 27.6875H26.3125C26.4688 27.6875 26.625 27.5625 26.625 27.375V23.875C26.625 21.375 24.8125 19.3125 22.4688 18.8438Z",
    fill: "#3077F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12293_33289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school_icon.458bc4aa854a01340cf4069c9096cf3b.svg";
export { ForwardRef as ReactComponent };